import * as React from "react";

import { ResponsivenessSetting, useResponsiveness } from "../hooks";

import { usePlpPresenterForTheFilterMenu_Desktop } from "../providers";

import { DesktopFilterMenu } from "../desktop-filter-menu";

import { Content } from "./content";

export const MainContent: React.FunctionComponent = () => {
  const [responsivenessSetting] = useResponsiveness();

  const { shouldShowTheFilterMenu_onDesktop } =
    usePlpPresenterForTheFilterMenu_Desktop();

  const showDesktopFilters =
    responsivenessSetting === ResponsivenessSetting.Desktop &&
    shouldShowTheFilterMenu_onDesktop;

  return (
    <div
      className={`main-content ${
        showDesktopFilters ? "show-filter-menu" : "hide-filter-menu"
      }`}
    >
      {showDesktopFilters && <DesktopFilterMenu />}
      <Content />
    </div>
  );
};
